module.exports = __webpack_public_path__ + "img/072.045f2a5f.png";